import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useLocation } from "react-router-dom";
import { Stack, IconButton, InputAdornment, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import CryptoJS from "crypto-js";

// import slogo from '../assets/img/logo.png';
// import unologo from '../assets/img/UNOLogo.png';
import welcomeimg1 from "../assets/images/welcomeimg1.svg";
import welcomeimg2 from "../assets/images/welcomeimg2.svg";
import apiClient from "../apiClient";
import { useDispatch, useSelector } from "react-redux";
import { applicationId, SECRET_KEY } from "../env";
import axios from "axios";
import { saveUserData } from "../store/slice/userSlice";
// import { CloseIcon } from '../SvgIconsData';

const Login = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.configSlice);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUserLogin = async () => {
    try {
      setLoading(true);

      const bodyData = {
        email: email.trim(),
        password: CryptoJS.AES.encrypt(password, SECRET_KEY).toString(),
      };

      let {data} = await axios.post(
        `${configData.config.UNO_URL}/api/auth/login/secure/${applicationId}`,
        bodyData
      );

      const userData = {
        token: data.data.token,
        user: data.data.user,
      };
      localStorage.setItem('token', userData.token);
      dispatch(saveUserData(userData));

    } catch (error) {
      console.log(error);
      setError(error?.response?.data?.message || "Something went wrong");
      setTimeout(()=>{ setError(null); },5000)
    }finally{
        setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> Login | Simulanis ModuleVault </title>
      </Helmet>
      <div className="loginPage">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <img
                className="uno"
                src="https://apps.simulanis.io/static/media/UNOLogo.32e9231ec13c5531e6b0.png"
                alt="UNO Logo"
              />
              <div className="wecomfimgg d-flex">
                <img src={welcomeimg2} alt="Welcome Image 2" />
                <img src={welcomeimg1} alt="Welcome Image 1" />
              </div>
            </div>

            <div className="col-md-5">
              <div className="card" style={{ position: "relative" }}>
                {show ? (
                  <span className="password-change-alert">
                    New password set successfully.
                    <span
                      className="close-alert"
                      onClick={() => {
                        setShow(false);
                        navigate("/login");
                      }}
                    ></span>
                  </span>
                ) : null}

                <div className="card-body p-4">
                  <h5 className="pt-2">Welcome to Simulanis!</h5>
                  <form>
                    <Stack spacing={3}>
                      <div className="form-group">
                        <p className="mb-1">Email*</p>
                        <TextField
                          name="email"
                          fullWidth
                          placeholder="Email address"
                          size="sm"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      <div className="form-group">
                        <div className="d-flex justify-content-between">
                          <p className="mb-1">Password*</p>
                        </div>
                        <TextField
                          name="password"
                          fullWidth
                          placeholder="Password"
                          size="sm"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          type="password"
                          autoComplete="off"
                        />
                      </div>
                    </Stack>

                    <div className="d-flex justify-content-between pt-0 mt-0 px-1">
                      {error && <span className="login-error"> {error} </span>}
                    </div>

                    {!loading ? (
                      <button
                        className="reset-page-btn mt-3"
                        size="large"
                        color="secondary"
                        type="button"
                        onClick={handleUserLogin}
                      >
                        Log in
                      </button>
                    ) : (
                      <button
                        className="reset-page-btn mt-3"
                        size="large"
                        color="secondary"
                        type="button"
                      >
                        <div className="loader-btn">
                          <span className="bar" />
                          <span className="bar" />
                          <span className="bar" />
                        </div>
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
